<div class="payment-integrations-list-page">
  <!-- Main Content Layout - show after initial load completes -->
  @if (!initialLoading()) {
    <div class="main-layout">
      <!-- Sidebar Toggle Area -->
      <div class="sidebar-toggle-area">
        <p-button
          [icon]="sidebarCollapsed() ? 'pi pi-angle-right' : 'pi pi-angle-left'"
          [text]="true"
          size="small"
          (onClick)="toggleSidebar()"
          [pTooltip]="
            sidebarCollapsed() ? 'Expand filters' : 'Collapse filters'
          "
          tooltipPosition="right"
          class="sidebar-toggle-btn"
        />

        <!-- Collapsed State Controls -->
        @if (sidebarCollapsed()) {
          <div class="collapsed-controls">
            <button
              class="collapsed-filter-btn"
              (click)="toggleSidebar()"
              [pTooltip]="'Filters'"
              tooltipPosition="right"
            >
              <i class="pi pi-filter"></i>
              @if (hasActiveFilters()) {
                <div class="filter-dot-indicator">
                  <i class="pi pi-circle-fill"></i>
                </div>
              }
            </button>
            @if (hasActiveFilters()) {
              <button
                class="collapsed-clear-btn"
                (click)="onClearFilters(); $event.stopPropagation()"
                [pTooltip]="'Clear All Filters'"
                tooltipPosition="right"
              >
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        }
      </div>

      <!-- Mobile Backdrop -->
      <div
        class="mobile-backdrop"
        [class.visible]="!sidebarCollapsed()"
        (click)="toggleSidebar()"
      ></div>

      <!-- Filter Sidebar -->
      <div class="filter-sidebar" [class.collapsed]="sidebarCollapsed()">
        <div class="sidebar-content">
          <app-payment-integrations-filters
            [filterForm]="filterForm"
            [loading]="loading()"
            [drawerMode]="true"
            (filtersChanged)="onFiltersChanged()"
            (clearFilters)="onClearFilters()"
          />
        </div>
      </div>

      <!-- Main Content Area -->
      <div class="content-area" [class.sidebar-open]="!sidebarCollapsed()">
        <!-- Toolbar -->
        <div
          class="content-toolbar surface-section border-bottom-1 surface-border"
        >
          <div class="toolbar-content">
            <div class="toolbar-left">
              <span class="record-count">
                {{ data()?.TotalCount || 0 }}
                {{ data()?.TotalCount === 1 ? "Integration" : "Integrations" }}
              </span>
            </div>
            <div class="toolbar-right">
              <p-button
                label="Add Integration"
                icon="pi pi-plus"
                size="small"
                (onClick)="onCreateNew()"
              />
            </div>
          </div>
        </div>

        <!-- Table Container -->
        <div class="table-container">
          <app-payment-integrations-table
            [data]="data()"
            [loading]="loading()"
            scrollHeight="flex"
            (sortChanged)="onSortChanged($event)"
            (pageChanged)="onPageChanged($event)"
            (rowAction)="onRowAction($event)"
          />
        </div>
      </div>
    </div>
  }

  <!-- Initial Loading Skeleton - only show during first load -->
  @if (initialLoading()) {
    <app-list-page-skeleton
      [sidebarCollapsed]="sidebarCollapsed()"
      filterPreset="paymentIntegrations"
      tablePreset="paymentIntegrations"
    />
  }

  <!-- Empty State (no site selected) -->
  @if (!siteId()) {
    <div class="empty-state-container">
      <div class="empty-state">
        <i class="pi pi-exclamation-circle"></i>
        <h2>No Site Selected</h2>
        <p>
          Please select a site from the navigation to view payment integrations.
        </p>
      </div>
    </div>
  }
</div>

<!-- Toast Messages - only render in embedded mode since main app has global toast -->
@if (embeddedMode) {
  <p-toast
    position="top-right"
    [breakpoints]="{ '920px': { width: '100%', right: '0', left: '0' } }"
  />
}

<!-- Confirmation Dialog -->
<p-confirmDialog
  [style]="{ width: '450px' }"
  [baseZIndex]="10000"
  rejectButtonStyleClass="p-button-text"
/>
